import { render, staticRenderFns } from "./PurchaseOrderDetailModal.vue?vue&type=template&id=3644eb14&scoped=true"
import script from "./PurchaseOrderDetailModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderDetailModal.vue?vue&type=style&index=0&id=3644eb14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644eb14",
  null
  
)

export default component.exports